import { render, staticRenderFns } from "./InventoryImages.vue?vue&type=template&id=244b9822&scoped=true"
import script from "./InventoryImages.vue?vue&type=script&lang=js"
export * from "./InventoryImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b9822",
  null
  
)

export default component.exports